'use client';

import { useState } from 'react';
import {
  Col, Button, Container, Form, Row,
} from 'reactstrap';

import UilCheck from '@iconscout/react-unicons/icons/uil-check-circle';
import { addNewsSubscription } from '../../services/users.service';
import { sendMetrics } from '../../services/ga.service';

const Subscribe = () => {
  const [success, setSuccess] = useState(false);
  const onSubscribe = (e) => {
    e.preventDefault();
    sendMetrics('new_subscription');
    addNewsSubscription(e.target.email.value);
    setSuccess(true);
    setTimeout(() => (setSuccess(false)), 5000);
  };

  // Success message
  const successMsg = success ? (
    <div role="alert" className="alert alert-success mt-2">
      <UilCheck className="fs-5 align-middle me-1" />
      You succesfully subscribed for SVGHMI.pro News!
    </div>
  ) : null;

  return (
    <Container className="mt-100 mt-60">
      <Row className="justify-content-center">
        <Col className="col-12 text-center">
          <div className="section-title">
            <h4 className="title mb-4">
              Want to know about our new features?
            </h4>
            <p className="text-muted para-desc mx-auto">
              Subscribe to stay up to date with all the updates,
              we&apos;re cooking up something extra tasty for you!
            </p>

            <div className="subcribe-form mt-4 pt-2">
              <Form onSubmit={onSubscribe}>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="rounded-pill border"
                  required
                  placeholder="E-mail :"
                  suppressHydrationWarning
                />
                <Button type="submit" color="primary" className="btn btn-pills">
                  Subscribe
                </Button>
                {successMsg}
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Subscribe;
